import type { HeavenlyStem } from '../types/stems';
import type { EarthlyBranch } from '../types/branches';

// 지장간 매핑: 지지 → [여기?, 중기?, 정기(본기)]
const HIDDEN_STEMS_MAP: Record<EarthlyBranch, HeavenlyStem[]> = {
  '子': ['壬', '癸'],
  '丑': ['癸', '辛', '己'],
  '寅': ['戊', '丙', '甲'],
  '卯': ['甲', '乙'],
  '辰': ['乙', '癸', '戊'],
  '巳': ['戊', '庚', '丙'],
  '午': ['丙', '己', '丁'],
  '未': ['丁', '乙', '己'],
  '申': ['戊', '壬', '庚'],
  '酉': ['庚', '辛'],
  '戌': ['辛', '丁', '戊'],
  '亥': ['戊', '甲', '壬'],
};

// 지장간 비율 (여기:중기:정기) — 30일 기준 비례 영향력
const HIDDEN_STEMS_RATIO: Record<EarthlyBranch, number[]> = {
  '子': [10, 20],
  '丑': [9, 3, 18],
  '寅': [7, 7, 16],
  '卯': [10, 20],
  '辰': [9, 3, 18],
  '巳': [7, 7, 16],
  '午': [10, 10, 10],
  '未': [9, 3, 18],
  '申': [7, 7, 16],
  '酉': [10, 20],
  '戌': [9, 3, 18],
  '亥': [7, 7, 16],
};

/** 지지의 지장간을 반환한다. [여기?, 중기?, 정기(본기)] */
export function getHiddenStems(branch: EarthlyBranch): HeavenlyStem[] {
  return [...HIDDEN_STEMS_MAP[branch]];
}

/** 지지의 정기(본기) 지장간을 반환한다 — 마지막 원소 */
export function getMainHiddenStem(branch: EarthlyBranch): HeavenlyStem {
  const stems = HIDDEN_STEMS_MAP[branch];
  return stems[stems.length - 1];
}

/** 지지의 지장간과 비례 비율을 반환한다 */
export function getHiddenStemsWithRatio(branch: EarthlyBranch): { stem: HeavenlyStem; ratio: number }[] {
  const stems = HIDDEN_STEMS_MAP[branch];
  const ratios = HIDDEN_STEMS_RATIO[branch];
  return stems.map((stem, i) => ({ stem, ratio: ratios[i] }));
}
